import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';

@Component({
  selector: 'activity-row-deal-document-rejected',
  template: `
    <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
      <mat-icon>remove_circle_outline</mat-icon>
    </div>
    <div class="description">
      <strong>Deal Document Rejected</strong>
      <div class="text">
        @if (activity.meta?.rejectedBy && activity.meta?.rejectedBy === lenderUser()?.id) {   
          You
        } @else {
          {{ activity.meta?.rejectedByUser }}
        }
        rejected {{ activity.meta?.document?.title }} for deal {{ activity.dealId }} [{{ activity.meta?.institutionName}}].
        <div class="tw-ml-[36px] tw-max-w-[400px] tw-font-semibold">
        Reason for rejection:
        <div [innerHTML]="activity.meta?.rejectedReason" class="tw-text-lendio-cool-gray-400 tw-font-normal tw-text-xs"></div>
      </div>
      </div>
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowDealDocumentRejectedComponent {
  lenderUser = this.store.selectSignal(LenderUserState.lenderUser);
  @Input() activity;

  constructor(
    private store: Store,
  ) {}
}
